module.exports = __webpack_public_path__ + "static/media/video_call.50a4a8ae.svg";